export const AGENDA_DROP_HIGHLIGHT_BG = '#FFF1EA'

const ACTIVE_DROP_TARGET_CLASS =
  'bg-[#FFF1EA] outline outline-2 outline-offset-[-2px] outline-[#ff5a1f]'
const BLOCKED_DROP_TARGET_CLASS =
  'outline outline-2 outline-offset-[-2px] outline-[#b0b5c3]'
const COLUMN_REORDER_TARGET_CLASS =
  'before:absolute before:inset-y-0 before:left-0 before:w-1 before:bg-[#ff5a1f]'
const COLUMN_REORDER_HEADER_CLASS = 'bg-[#FFF1EA]'

export function agendaDropTargetClass(active: boolean, blocked = false) {
  if (!active) return null
  return blocked ? BLOCKED_DROP_TARGET_CLASS : ACTIVE_DROP_TARGET_CLASS
}

export function agendaColumnReorderTargetClass(active: boolean) {
  return active ? COLUMN_REORDER_TARGET_CLASS : null
}

export function agendaColumnReorderHeaderClass(active: boolean) {
  return active ? COLUMN_REORDER_HEADER_CLASS : 'bg-white'
}
